import { APICore } from "./apiCore";

const api = new APICore();

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const SOUND_ENDPOINT = 'api/v1/admin/sounds';


function searchSounds(params: any) {
    return api.get(`${baseUrl}/${SOUND_ENDPOINT}`, params);
}


function getSoundDetail(soundId: string) {
    return api.get(`${baseUrl}/${SOUND_ENDPOINT}/${soundId}`, {});
}

function createSound(data: any) {
    return api.createWithFile(`${baseUrl}/${SOUND_ENDPOINT}`, data);
}

function updateSound(soundId: string, data: any) {
    return api.updateWithFilePut(`${baseUrl}/${SOUND_ENDPOINT}/${soundId}`, data);
}

function deleteSound(soundId: string) {
    return api.delete(`${baseUrl}/${SOUND_ENDPOINT}/${soundId}`);
}

export {
    searchSounds,
    getSoundDetail,
    createSound,
    updateSound,
    deleteSound
}